import { useFieldIfAvailable } from "../../../core/useFieldIfAvailable";
import { FormGroup, Select, Text } from 'tombac';
import { jsx as _jsx } from "react/jsx-runtime";
function getOptions(schema) {
  if (schema.type === 'SELECT' || schema.type === 'MULTISELECT') {
    return schema.properties.options;
  }
  return [];
}
export default function SelectLimitEditor({
  className,
  defaultLimit,
  isSharedWithOther = false,
  label,
  limit,
  onChange,
  schema
}) {
  const [field,, helpers] = useFieldIfAvailable(schema.name);
  const options = getOptions(schema);

  // Determine the value: prefer limit, then defaultLimit, then schema default, then empty string
  let value = limit ?? defaultLimit ?? '';
  if (value === '' && options.length > 0) {
    const defaultOpt = options.find(opt => opt.default);
    if (defaultOpt) value = defaultOpt.value;
  }
  let setValue = onChange;
  if (field) {
    value = field.value ?? value;
    setValue = helpers.setValue;
  }
  const selected = options.find(option => option.value === value) || null;
  return /*#__PURE__*/_jsx(FormGroup, {
    className: className,
    htmlFor: `select-${schema?.name}`,
    label: label,
    $width: "100%",
    "data-sentry-element": "FormGroup",
    "data-sentry-component": "SelectLimitEditor",
    "data-sentry-source-file": "SelectLimitEditor.tsx",
    children: options.length === 0 ? /*#__PURE__*/_jsx(Text, {
      $color: "neutral.500",
      fontSize: 14,
      children: "No options available"
    }) : /*#__PURE__*/_jsx(Select, {
      id: `select-${schema?.name}`,
      options: options,
      value: selected,
      onChange: option => setValue?.(option?.value ?? ''),
      isDisabled: isSharedWithOther,
      isClearable: false,
      $width: "100%"
    })
  });
}